import React from "react";
import { DocumentCard, 
    DocumentCardDetails, 
    DocumentCardTitle, 
    DocumentCardActivity,
    Link } from '@fluentui/react';
import InfoTooltip from "../formFields/InfoTooltip";
import { mapUserForPeople } from "../../helpers/HelperMethods";

const CopilotCreditsUsage = ({ usage }) => {

    const logo = <span className='cardLogo copilotLogo' />;
    const envUrl = `https://make.powerautomate.com/environments/${usage.environment.internalId}/flows`

    return (
        <div>
            <DocumentCard styles={cardStyles}>
                <DocumentCardDetails>
                    <div style={headerStyles}>
                        {logo}
                        <div style={titleContainerStyles}>
                            <DocumentCardTitle title='Copilot Credits' shouldTruncate={false} styles={titleStyles} />
                        </div>
                    </div>
                    <div style={statusStyles}>Usage from Environment: <Link href={envUrl} target='_blank'><b>{usage.environment.name}</b></Link></div>
                    <div style={statusStyles}>Usage source: <Link href={usage.flow.url} target='_blank'><b>{usage.flow.name}</b></Link></div>
                    <div style={statusStyles}>
                        <div>
                            <div><b>Estimated avarage monthly usage<InfoTooltip content='Calculated based on last 3 months' /></b></div>
                            <div>{usage.avgMonthlyUsage} Copilot Credits</div>
                            <div>{usage.avgMonthlyCost} USD</div>
                        </div>
                    </div>
                    <div style={ownersStyles}>
                        <DocumentCardActivity 
                            activity={`Primary owner`} 
                            people={mapUserForPeople(usage.flow.primaryOwner)}
                            styles={ownerStyles}
                        />
                        <DocumentCardActivity 
                            activity={`Secondary owner`} 
                            people={mapUserForPeople(usage.flow.secondaryOwner)} 
                            styles={ownerStyles}
                        />
                    </div>
                </DocumentCardDetails>
            </DocumentCard>
        </div>
    );
}

const statusStyles = {
    padding: '8px 16px',
    fontSize: '12px'
}

const headerStyles = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
}

const cardStyles = {
    root: {  
        marginRight: 20, 
        marginBottom: 20, 
        width: 400,
        maxWidth: 400,
        height: 240,
        border: '1px solid black'
    }
}

const titleContainerStyles = {
    display: 'flex',
    height: 54,
    flex: 1,
    alignItems: 'center',
    overflow: 'hidden'
}

const titleStyles = {
    root: {
        flexGrow: 1,
        height: 'auto'
    }
}

const ownersStyles = {
    display: 'flex',
    justifyContent: 'space-between'
}

const ownerStyles = {
    root: {
        width: 200
    }
}

export default CopilotCreditsUsage


// WEBPACK FOOTER //
// ./src/components/ManageCenter/CopilotCreditsUsage.js